import NewAdminMessageButton from "../admin-messages/list/components/NewAdminMessageButton/NewAdminMessageButton";
import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import { compose } from "recompose";
import { AdminMessagesTable } from "../admin-messages/list/components/AdminMessagesTable/AdminMessagesTable";
import WithAjax from "../common/helpers/WithAjax";

export const SkillVendorEditAdminMessagesTab = (props) => {
  return (
    <div>
      <AdminMessagesTable ajax={props.ajax} initialFilter={{ SkillVendorId: props.skillVendorId }} />

      <NewAdminMessageButton className="mt-2" skillVendorIds={[props.skillVendorId]} history={props.history} recipients={`${props.overview.FullName} (1)`} />
    </div>
  );
};

const mapStateToProps = (state, ownProps) => ({
  overview: state.skillVendorPage.overview,
});
const mapDispatchToProps = (dispatch) => ({});
export default compose(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )
)(withRouter(WithAjax(SkillVendorEditAdminMessagesTab)));
